import Owl from './Owl';
import BeeTree from './BeeTree';
import Bee from './Bee';
import Tent from './Tent';
import Stump from './Stump';
import Bench from './Bench';
import LizardRock from './LizardRock';
import RolyPolyLog from './RolyPolyLog';
import Campfire from './Campfire';
import Bin from './Bin';
import Dandelion from './Dandelion';
import Composter from './Composter';
import AntHill from './AntHill';
import Ant from './Ant';
import Pond from './Pond';
import WaterRock from './WaterdRock';
import Lantern from './Lantern';
import Chair from './Chair';
import StoolLog from './StoolLog';
import Firefly from './Firefly';
import YellowFlowers from './YellowFlowers';
import ButterflyCycle from './ButterflyCycle';
import Pampas from './Pampas';

export default class FurnitureFactory {
  constructor(game, location, furnituresByID) {
    this.game = game;
    this.location = location;
    this.furnituresByID = furnituresByID;
  }

  getObject(data) {
    const { id } = data;
    data = { ...this.furnituresByID[id], ...data };
    // console.log(data);
    let object;
    switch (id) {
      case 'owl':
        object = new Owl({ game: this.game, location: this.location, data });
        break;
      case 'bee_tree':
        object = new BeeTree({ game: this.game, location: this.location, data });
        break;
      case 'yellow_flowers':
      case 'poppies':
        object = new YellowFlowers({ game: this.game, location: this.location, data });
        break;
      case 'pampas':
        object = new Pampas({ game: this.game, location: this.location, data });
        break;
      case 'bee':
        object = new Bee({ game: this.game, location: this.location, data });
        break;
      case 'tent_1':
      case 'tent_2':
      case 'tent_3':
        object = new Tent({ game: this.game, location: this.location, data });
        break;
      case 'stump':
        object = new Stump({ game: this.game, location: this.location, data });
        break;
      case 'bench':
        object = new Bench({ game: this.game, location: this.location, data });
        break;
      case 'lizard_rock':
        object = new LizardRock({ game: this.game, location: this.location, data });
        break;
      case 'roly_poly_log':
        object = new RolyPolyLog({ game: this.game, location: this.location, data });
        break;
      case 'campfire':
        object = new Campfire({ game: this.game, location: this.location, data });
        break;
      case 'dandelion':
        object = new Dandelion({ game: this.game, location: this.location, data });
        break;
      case 'bin':
      case 'bin_recycle':
        object = new Bin({ game: this.game, location: this.location, data });
        break;
      case 'composter':
        object = new Composter({ game: this.game, location: this.location, data });
        break;
      case 'ant_hill':
        object = new AntHill({ game: this.game, location: this.location, data });
        break;
      case 'ant':
        object = new Ant({ game: this.game, location: this.location, data });
        break;
      case 'pond':
        object = new Pond({ game: this.game, location: this.location, data });
        break;
      case 'water_rock':
        object = new WaterRock({ game: this.game, location: this.location, data });
        break;
      case 'lantern_back':
      case 'lantern_front':
        object = new Lantern({ game: this.game, location: this.location, data });
        break;
      case 'chair':
        object = new Chair({ game: this.game, location: this.location, data });
        break;
      case 'stool_log':
        object = new StoolLog({ game: this.game, location: this.location, data });
        break;
      case 'firefly':
        object = new Firefly({ game: this.game, location: this.location, data });
        break;
      case 'butterfly_cycle':
        object = new ButterflyCycle({ game: this.game, location: this.location, data });
        break;
    }

    return object;
  }
}
